const pageLogin = document.querySelector( '.n-page-login' )
if( pageLogin ) {
  const connexionBlock = pageLogin.querySelector( '.n-block:nth-of-type(1)' )
  const inscriptionBlock = pageLogin.querySelector( '.n-block:nth-of-type(2)' )

  const connexionTitle = connexionBlock.querySelector( '.title' ).textContent.trim()
  const inscriptionTitle = inscriptionBlock.querySelector( '.title' ).textContent.trim()

  const connexionNav = document.createElement( 'nav' )
  const connexionLink = document.createElement( 'div' )
  connexionLink.append( connexionTitle )
  const inscriptionLink = document.createElement( 'div' )
  inscriptionLink.append( inscriptionTitle )
  connexionNav.append( connexionLink )
  connexionNav.append( inscriptionLink )
  const inscriptionNav = connexionNav.cloneNode( true )

  connexionNav.querySelector( 'div:nth-of-type(2)' ).classList.add( 'off' )
  inscriptionNav.querySelector( 'div:nth-of-type(1)' ).classList.add( 'off' )

  connexionNav.querySelector( '.off' ).addEventListener( 'click', () => {
    connexionBlock.style.display = 'none'
    inscriptionBlock.style.display = 'block'
  } )
  inscriptionNav.querySelector( '.off' ).addEventListener( 'click', () => {
    connexionBlock.style.display = 'block'
    inscriptionBlock.style.display = 'none'
  } )

  connexionBlock.querySelector( '.container' ).prepend( connexionNav )
  inscriptionBlock.querySelector( '.container' ).prepend( inscriptionNav )
}
